<div class="route-aggregator">
  <!-- Left Sidebar - Route List -->
  <div class="sidebar">
    <div class="sidebar-header">
      <h3>Available Routes</h3>
      <button class="close-btn" (click)="closeDebugView()">×</button>
    </div>
    <div class="route-list">
      <div 
        class="route-item" 
        [class.selected]="route.path === selectedRoute"
        *ngFor="let route of routeList"
        (click)="selectRoute(route)">
        <div class="route-path">{{ route.path || 'home' }}</div>
        <div class="route-name">{{ route.displayName }}</div>
      </div>
    </div>
  </div>

  <!-- Right Main View -->
  <div class="main-view">
    <!-- Main Header -->
    <div class="main-header">
      <h2>Component Debug View</h2>
      <div class="view-controls">
        <div class="view-toggle">
          <button 
            class="view-btn" 
            [class.active]="currentView === 'list'"
            (click)="switchView('list')">
            📋 List
          </button>
          <button 
            class="view-btn" 
            [class.active]="currentView === 'grid'"
            (click)="switchView('grid')">
            📊 Grid
          </button>
        </div>
        <div class="filters-placeholder">
          <p>Filters will be added here later</p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- List View -->
      <div *ngIf="currentView === 'list'" class="list-view">
        <div class="content-info">
          <h4>Selected Route: {{ selectedRoute || 'None selected' }}</h4>
          <p>Click a route from the sidebar to view its component here.</p>
        </div>
        
        <!-- Component Display Area -->
        <div class="component-display" [class.dark-background]="needsDarkBackground()">
          <ng-container #componentContainer></ng-container>
        </div>
      </div>

      <!-- Grid View -->
      <div *ngIf="currentView === 'grid'" class="grid-view">
        <div class="grid-header">
          <h4>Claim Flow Overview - All Components</h4>
          <p>Grid view showing all {{ routeList.length }} components in the claim flow</p>
        </div>
        
        <div class="components-grid">
          <div 
            class="grid-card" 
            *ngFor="let route of routeList"
            [class.selected]="route.path === selectedRoute"
            (click)="selectRoute(route)">
            <div class="card-header">
              <div class="route-path">{{ route.path || 'home' }}</div>
            </div>
            <div class="card-title">{{ route.displayName }}</div>
            <div class="card-preview">
              <div class="component-wrapper">
                <ng-container #gridContainer></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>